module.exports = __webpack_public_path__ + "static/img/2.07402e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/4/2.png
// module id = e4bo
// module chunks = 0